// extracted by mini-css-extract-plugin
export var black = "_2x-6";
export var brand = "_2x-1";
export var ddefault = "_2x-0";
export var error = "_2x-3";
export var gray = "_2x-2";
export var highContrast = "_2x-8";
export var outline = "_2x-7";
export var success = "_2x-5";
export var warning = "_2x-4";